import request from '@/utils/request'
import store from '@/store'

function getAdminId() {
  return store.state.userInfo?.id || store.state.userInfo?.adminId || JSON.parse(localStorage.getItem('userInfo') || '{}').id
}

export function addFixedPhone(data) {
  return request({
    url: '/admin/fixed-phones',
    method: 'post',
    data: {
      ...data,
      adminId: getAdminId()
    }
  })
}

export function deleteFixedPhone(id) {
  return request({
    url: `/admin/fixed-phones/${id}`,
    method: 'delete'
  })
}

export function getFixedPhoneList() {
  return request({
    url: '/admin/fixed-phones',
    method: 'get',
    params: {
      adminId: getAdminId()
    }
  })
}

export function getMallUserListApi(params) {
  return request({
    url: '/mall/user/list',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

export function getAdminExchangeListApi(params) {
  return request({
    url: '/mall/exchange/admin/list',
    method: 'get',
    params: {
      ...params,
      adminId: getAdminId()
    }
  })
}

export function verifyExchangeApi(id) {
  return request({
    url: `/mall/exchange/verify/${id}`,
    method: 'post'
  })
}

export function resetActivityByCode(code) {
  return request({
    url: '/admin/resetActivityByCode?code=' + code,
    method: 'post',
    data: {  }
  })
}

// ==================== 门店管理 ====================

export function createShop(data) {
  return request({
    url: '/admin/shop',
    method: 'post',
    data
  })
}

export function getShopList() {
  return request({
    url: '/admin/shop/list',
    method: 'get'
  })
}

export function getShopDetail(id) {
  return request({
    url: `/admin/shop/${id}`,
    method: 'get'
  })
}

export function updateShop(id, data) {
  return request({
    url: `/admin/shop/${id}`,
    method: 'put',
    data
  })
}

export function updateShopStatus(id, status) {
  return request({
    url: `/admin/shop/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function deleteShop(id) {
  return request({
    url: `/admin/shop/${id}`,
    method: 'delete'
  })
}

// ==================== 奖品管理 ====================

export function getPrizeListApi(params) {
  return request({
    url: '/admin/prize/list',
    method: 'get',
    params
  })
}

export function createPrize(data) {
  return request({
    url: '/admin/prize',
    method: 'post',
    data
  })
}

export function getPrizeDetail(id) {
  return request({
    url: `/admin/prize/${id}`,
    method: 'get'
  })
}

export function updatePrizeApi(id, data) {
  return request({
    url: `/admin/prize/${id}`,
    method: 'put',
    data
  })
}

export function updatePrizeStatus(id, status) {
  return request({
    url: `/admin/prize/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function updatePrizeStock(id, stock) {
  return request({
    url: `/admin/prize/${id}/stock`,
    method: 'put',
    params: { stock }
  })
}

// ==================== 兑换码管理 ====================

export function getCodePage(data) {
  const batchId = data.batchId || 0
  return request({
    url: `/admin/batch/${batchId}/codes`,
    method: 'post',
    data: {
      ...data,
      batchId
    }
  })
}

export function getBatchList(params) {
  return request({
    url: '/admin/batch/page',
    method: 'get',
    params
  })
}

export function createBatch(data) {
  return request({
    url: '/admin/batch',
    method: 'post',
    data
  })
}

export function exportCodeExcel(batchId) {
  return request({
    url: batchId ? `/admin/batch/${batchId}/export/excel` : '/admin/code/export/excel',
    method: 'get',
    responseType: 'blob'
  })
}

// ==================== 核销与兑现管理 ====================

export function getRules() {
  return request({
    url: '/user/rules',
    method: 'get'
  })
}

export function superVerify(data, query) {
  return request({
    url: '/admin/verify',
    method: 'post',
    params: query,
    data
  })
}

export function getCashoutPending(params) {
  return request({
    url: '/admin/cashout/pending',
    method: 'get',
    params
  })
}

export function getCashoutDone(params) {
  return request({
    url: '/admin/cashout/done',
    method: 'get',
    params
  })
}

export function executeCashout(data) {
  return request({
    url: '/admin/cashout',
    method: 'post',
    data
  })
}

// ==================== 黑名单管理 ====================

export function getBlacklistList() {
  return request({
    url: '/admin/blacklist/list',
    method: 'get'
  })
}

export function addBlacklist(data) {
  return request({
    url: '/admin/blacklist',
    method: 'post',
    data
  })
}

export function removeBlacklist(id) {
  return request({
    url: `/admin/blacklist/${id}`,
    method: 'delete'
  })
}

// ==================== 数据中心 ====================

export function getShopRanking(params) {
  return request({
    url: '/admin/data/ranking',
    method: 'get',
    params
  })
}

export function getGlobalStats(params) {
  return request({
    url: '/admin/data/global-stats',
    method: 'get',
    params
  })
}

export function getShopStats(shopId, params) {
  return request({
    url: `/admin/data/shop-stats/${shopId}`,
    method: 'get',
    params
  })
}

export function getDataRecords(params) {
  return request({
    url: '/admin/data/records',
    method: 'get',
    params
  })
}

export function getVerifyRecords(data) {
  return request({
    url: '/admin/data/verify-records',
    method: 'post',
    data
  })
}

export function exportGlobalData(params) {
  return request({
    url: '/admin/data/export/global',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

export function exportShopStats(shopId, params) {
  return request({
    url: `/admin/data/export/shop-stats/${shopId}`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// ==================== 系统配置 ====================

export function getConfigList() {
  return request({
    url: '/admin/config/list',
    method: 'get'
  })
}

export function getConfigGroup(group) {
  return request({
    url: `/admin/config/group/${group}`,
    method: 'get'
  })
}

export function saveConfig(data) {
  return request({
    url: '/admin/config/save',
    method: 'post',
    data
  })
}

export function batchSaveConfig(data) {
  return request({
    url: '/admin/config/batch',
    method: 'post',
    data
  })
}

export function getActivityRuleContent() {
  return request({
    url: '/admin/config/rule-content',
    method: 'get'
  })
}

export function saveActivityRuleContent(data) {
  return request({
    url: '/admin/config/rule-content',
    method: 'post',
    data
  })
}

export function toggleActivity(enabled) {
  return request({
    url: '/admin/config/toggle',
    method: 'post',
    params: { enabled }
  })
}

export function getKefuContent() {
  return request({
    url: '/admin/config/kefu-content',
    method: 'get'
  })
}

export function saveKefuContent(data) {
  return request({
    url: '/admin/config/kefu-content',
    method: 'post',
    data
  })
}

export function getBgImages() {
  return request({
    url: '/admin/config/bg-images',
    method: 'get'
  })
}

export function saveBgImages(data) {
  return request({
    url: '/admin/config/bg-images',
    method: 'post',
    data
  })
}

export function uploadBgImage(data) {
  return request({
    url: '/admin/prize/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getSysAdminList(params) {
  return request({
    url: '/admin/sys-admin/page',
    method: 'get',
    params
  })
}

export function createSysAdmin(data) {
  return request({
    url: '/admin/sys-admin',
    method: 'post',
    data
  })
}

export function updateSysAdmin(id, data) {
  return request({
    url: `/admin/sys-admin/${id}`,
    method: 'put',
    data
  })
}

export function deleteSysAdmin(id) {
  return request({
    url: `/admin/sys-admin/${id}`,
    method: 'delete'
  })
}

export function updateSysAdminStatus(id, status) {
  return request({
    url: `/admin/sys-admin/${id}/status`,
    method: 'put',
    params: { status }
  })
}

export function resetSysAdminPassword(id, newPassword) {
  return request({
    url: `/admin/sys-admin/${id}/password`,
    method: 'put',
    params: { newPassword }
  })
}